var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-spinner"},[(_vm.spinner === 'half-spinner')?_c('half-circle-spinner',{attrs:{"animation-duration":800,"size":_vm.size,"color":_vm.color}}):(_vm.spinner === 'spring-spinner')?_c('spring-spinner',{attrs:{"animation-duration":800,"size":_vm.size,"color":_vm.color}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }